import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=48292a27&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"
import style0 from "./popup.vue?vue&type=style&index=0&id=48292a27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48292a27",
  null
  
)

export default component.exports